import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    defaultPagination: {
      q: '',
      sortBy: 'username',
      page: 1,
      rowsPerPage: 10,
      descending: false,
      totalItems: 0
    }
  },
  getters: {
    defaultPagination (state) {
      return state.defaultPagination
    }
  },
  actions: {
    lookup ({ commit, dispatch }, username) {
      return Vue.axios.get(`${config.serverURI}/officers/lookup/${username}`)
    },
    fetchItem ({ commit, dispatch }, payload) {
      return Vue.axios.get(`${config.serverURI}/officers/${payload}`)
    },
    create ({ commit, dispatch }, payload) {
      return Vue.axios.post(`${config.serverURI}/officers`, payload)
    },
    update ({ commit, dispatch }, payload) {
      return Vue.axios.put(`${config.serverURI}/officers/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      return Vue.axios.put(`${config.serverURI}/officers/${payload.id}`, { enabled: false })
    },
    list ({commit, state, getters}) {
      return Vue.axios.get(config.serverURI + '/officers/list')
    },
    loadItems ({commit, state, getters}, pagination) {
      if (!pagination) pagination = getters.defaultPagination
      return Vue.axios.get(config.serverURI + '/officers/page', { params: pagination })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/officer.js